import React, { useState } from "react"
import { navigate } from "gatsby"
import styles from "./contactus-form.module.css"
import global from "../../Global.module.css"
import { useForm, ValidationError } from '@formspree/react';

const ContactUsForm = props => {
  const [state, handleSubmit] = useForm("mknkorqv");

  return (
    <div className={styles.FormWrapper}>
      <div className={styles.FormCopy}>
        <h2>Contact Us</h2>
        <p>Let us know what's up?</p>
      </div>
      {state.succeeded ? <div><p>Thanks for contacting us.  We'll get back to you ASAP!</p></div> :
      <form
        onSubmit={handleSubmit}
        className={styles.Form}
      >
        <div className={styles.Input}>
          <input
            type="text"
            name="name"
            placeholder="NAME"
            required
            maxLength="30"
          />
          <ValidationError 
            prefix="Name" 
            field="name"
            errors={state.errors}
          />
          <input
            type="email"
            name="email"
            placeholder="EMAIL"
            required
            maxLength="50"
          />
          <ValidationError 
            prefix="Email" 
            field="email"
            errors={state.errors}
          />
          <textarea
            id="message"
            name="message"
          />
          <ValidationError 
            prefix="Message" 
            field="message"
            errors={state.errors}
          />
        </div>
        <button type="submit" disabled={state.submitting}>Submit</button>
      </form>
    }
    </div>
  )
}

export default ContactUsForm
